<div class="wrappers1">
  <app-header></app-header>

  <div class="content">

    <app-menu></app-menu>
    <div class="row col-md-12 p-2 justify-content-center">
      <div class="col-md-7">
        <div class="mt-5">
          <!-- <div class="firstshift">Welcome Back! Let’s Continue Your Search</div> -->
          <!-- <div class="firstshift">Properties to buy in {{showcityname}}</div><br> -->
          <div class="containerthiss">

            <div> <span
                style="color: #004aad; font-weight: 800; ">Home</span>
              to stay. <span
                style="color: #004aad; font-weight: 800; ">Shop</span>
              to Grow. <span
                style="color: #004aad; font-weight: 800; ">Rent</span>
              It.
            </div>

          </div><br>
          <!-- <div class="radio-groups">
            <label class="radio-option">
              <input type="radio" name="choice" value="buy" checked />
              Buy
            </label>
            <label class="radio-option">
              <input type="radio" name="choice" value="rent" />
              Rent
            </label>
          </div> -->
        </div>
        <link rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" />

        <!-- Top Tabs -->
        <div class="mt-3 tabpropease"
          style="background-color: #004aad; padding: 5px 15px; color: #ffffff; border-radius: 20px 20px 0 0;">
          <mat-tab-group (selectedTabChange)="onTabChange($event)"
            class="white-tabs">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
          </mat-tab-group>
        </div>

        <!-- Search Bar Container -->
        <div class="custom-search">
          <div class="row align-items-center w-100 m-0 px-3">

            <!-- Location Block -->
            <div class="col-md-3">
              <label class="field-label">Location</label>

              <div class="position-relative">
                <input type="text"
                  class="form-control city-input"
                  style="cursor: pointer;"
                  [(ngModel)]="searchCityQuery"
                  (keyup)="searchCity(searchCityQuery)"
                  (click)="onCityInputClick()"
                  (focus)="onCityInputClick()"
                  (blur)="hideCitySuggestions()"
                  [placeholder]="selectedCityName ? selectedCityName : 'Search City...'"
                  #cityInput />

                <i *ngIf="!showCitySuggestions || cityDataList.length === 0"
                  class="fa fa-chevron-down dropdown-icon"
                  (mousedown)="$event.preventDefault(); openCitySuggestions()">
                </i>

                <!-- Chevron Up: only shown when dropdown is open -->
                <i *ngIf="showCitySuggestions && cityDataList.length > 0"
                  class="fa fa-chevron-up dropdown-icon"
                  (mousedown)="$event.preventDefault(); closeCitySuggestions()">
                </i>

                <ul *ngIf="shouldShowCitySuggestions"
                  class="suggestion-dropdownss">
                  <li *ngFor="let city of cityDataList"
                    (mousedown)="selectCity(city)"
                    [class.selected]="city.id === selectedCityId">
                    {{ city.name }}
                  </li>
                </ul>
              </div>

            </div>

            <!-- Locality Block -->
            <div class="col-md-4 border-left-custom">
              <label class="field-label">Locality</label>
              <div class="position-relative">
                <input type="text" #searchkey class="form-control search-input"
                  [(ngModel)]="searchQuery"
                  (keyup)="onclickSearch()" (click)="onclickSearch()"
                  (blur)="hideSuggestions()"
                  placeholder="Search locality" />
                <i class="fa fa-map-marker-alt location-icon"
                  style="cursor: pointer;"
                  (click)="onIconClickloc(searchkey)"></i>
                <ul *ngIf="showSuggestions && areaList?.length > 0"
                  class="suggestion-dropdown">
                  <li *ngFor="let area of areaList"
                    (mousedown)="selectArea(area)"
                    (input)="isAreaSelected = false">
                    {{ area.area | titlecase }}, {{ area.cityName | titlecase }}
                  </li>
                </ul>
              </div>
            </div>

            <!-- Budget Block -->
            <div class="col-md-3 border-left-custom">
              <label class="field-label">Budget</label>
              <div class="position-relative">
                <input
                  #budgetInput
                  type="text"
                  class="form-control search-input"
                  [(ngModel)]="budgetQuery"
                  (keyup)="onBudgetSearch()"
                  (click)="onBudgetClick()"
                  (blur)="showBudgetSuggestions = false"
                  (focus)="selectclears()"
                  placeholder="Search Budget" />

                <i
                  class="fa fa-wallet location-icon" style="cursor: pointer;"
                  (click)="onIconClick(budgetInput)"></i>

                <ul *ngIf="showBudgetSuggestions" class="suggestion-dropdown">
                  <li
                    *ngFor="let option of filteredBudgetOptions"
                    (mousedown)="selectBudget(option)">
                    {{ option.label }}
                  </li>
                </ul>
              </div>
            </div>

            <!-- Search Button -->
            <div
              class="col-md-2 d-flex justify-content-end align-items-end border-left-custom p-2">

              <button class="btn search-btn btn search-btn w-100 setbutton"
                (click)="searchArt()"
                [disabled]="!isAreaSelected">Search</button>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
  <div class="col-md-12 top-propease" style=" z-index: 0;">
    <div class="set_container">
      <div class="d-flex justify-content-between align-items-center mb-2 ">
        <span class="topproject">Top Property For Rent : Residential</span>
        <!-- <button (click)="navigateTOhomeresi()"
          class="btn btn-primary  setbutton">All
          Property </button> -->
        <button (click)="navigateTOhomeresi()"
          class="btn btn-primary setbutton d-flex align-items-center">
          <i class="fa fa-eye d-sm-none" aria-hidden="true"></i>
          <!-- Show only on small screens -->
          <span class="d-none d-sm-inline">All Property</span>
          <!-- Show only on larger screens -->
        </button>

      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loading"
      style="width: 100%; text-align: center; padding: 2rem;">
      <img src="https://i.gifer.com/ZZ5H.gif" alt="Loading..."
        style="width: 80px; height: 80px;">
    </div>

    <!-- Show "No records found" if loaded and no data -->
    <div *ngIf="!loading && showNoRecordsMessage; else showSwipers"
      style="width: 100%; text-align: center; padding: 2rem;">
      <img src="../../assets/images/notfound1.jpg" alt="No records"
        style="width: 150px; margin-bottom: 1rem;">

      <p style="font-size: 1.2rem; color: #666;">Rental property not available
        for this city.</p>
    </div>

    <!-- Show Swipers -->
    <ng-template #showSwipers>
      <!-- First Swiper -->
      <!-- Desktop Swiper View -->
      <ng-container *ngIf="!isMobile; else mobileList">
        <div class="swiper-container"
          style="width: auto !important; cursor: pointer; margin-top: 1pc;">
          <swiper #swiperRef2 [slidesPerView]="1" [spaceBetween]="30"
            [navigation]="{ nextEl: '.custom-next-button2', prevEl: '.custom-prev-button2' }"
            (slideChange)="onSlideChange2($event)" [breakpoints]="{
        '768': { 'slidesPerView': 3 }
      }" style="width: 75%;">
            <ng-template swiperSlide
              *ngFor="let card of residential.slice(0,3)">
              <app-rent-fuprop [propertyData]="card"></app-rent-fuprop>
            </ng-template>
          </swiper>
        </div>
      </ng-container>

      <!-- Mobile Column View -->
      <ng-template #mobileList>
        <div
          style="display: flex; flex-direction: column; gap: 1rem; margin-top: 1pc;">
          <app-rent-fuprop *ngFor="let card of residential.slice(0,3)"
            [propertyData]="card"></app-rent-fuprop>
        </div>
      </ng-template>

      <br>

      <!-- Second Swiper -->
      <!-- Desktop Swiper View -->
      <ng-container *ngIf="!isMobile; else mobileList2">
        <div class="swiper-container"
          style="width: auto !important; cursor: pointer; position: relative;">
          <swiper #swiperRef2 [slidesPerView]="1" [spaceBetween]="30"
            [navigation]="{ nextEl: '.custom-next-button2', prevEl: '.custom-prev-button2' }"
            (slideChange)="onSlideChange2($event)" [breakpoints]="{
        '768': { 'slidesPerView': 3 }
      }" style="width: 75%;">
            <ng-template swiperSlide *ngFor="let card of residential.slice(3)">
              <app-rent-fuprop [propertyData]="card"></app-rent-fuprop>
            </ng-template>
          </swiper>
        </div>
      </ng-container>

      <!-- Mobile Column View -->
      <ng-template #mobileList2>
        <div
          style="display: flex; flex-direction: column; gap: 1rem; margin-top: 1pc;">
          <app-rent-fuprop *ngFor="let card of residential.slice(3)"
            [propertyData]="card"></app-rent-fuprop>
        </div>
      </ng-template>

    </ng-template>

  </div>

  <div class="col-md-12 top-propeasemm" style=" z-index: 0;">
    <div class=" set_container">
      <div class="d-flex justify-content-between align-items-center mb-2 ">
        <span class="topproject">Top Property For Rent : Commercial</span>
        <!-- <button (click)="navigateTOhomecomm()"
          class="btn btn-primary setbutton">All
          Property </button> -->
        <button (click)="navigateTOhomecomm()"
          class="btn btn-primary setbutton d-flex align-items-center">
          <i class="fa fa-eye d-sm-none" aria-hidden="true"></i>
          <!-- Show only on small screens -->
          <span class="d-none d-sm-inline">All Property</span>
          <!-- Show only on larger screens -->
        </button>

      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="lodcommver"
      style="width: 100%; text-align: center; padding: 2rem;">
      <img src="https://i.gifer.com/ZZ5H.gif" alt="Loading..."
        style="width: 80px; height: 80px;">
    </div>
    <!-- src\assets\images\BZ2N (1).gif -->
    <!-- Show "No records found" if loaded and no data -->
    <div *ngIf="!lodcommver && showNocommers; else showcommers"
      style="width: 100%; text-align: center; padding: 2rem;">
      <img src="../../assets/images/notfound1.jpg" alt="No records"
        style="width: 150px; margin-bottom: 1rem;">
      <p style="font-size: 1.2rem; color: #666;"> Rental property not available
        for this city.</p>
    </div>
    <ng-template #showcommers>
      <!-- Desktop/Tablet View -->
      <ng-container *ngIf="!isMobile; else mobileCommers">
        <div class="swiper-container"
          style="display: flex; width: auto !important; cursor: pointer; margin-top: 1pc;">
          <swiper #swiperRef2 [slidesPerView]="1" [spaceBetween]="30"
            [navigation]="{ nextEl: '.custom-next-button2', prevEl: '.custom-prev-button2' }"
            (slideChange)="onSlideChange2($event)" [breakpoints]="{
          '768': { 'slidesPerView': 3 }
        }" style="width: 75%;">
            <ng-template swiperSlide
              *ngFor="let cards of commercial.slice(0,3)">
              <app-rent-fuprop [propertyData]="cards"></app-rent-fuprop>
            </ng-template>
          </swiper>
        </div>
        <br>
        <div class="swiper-container"
          style="display: flex; width: auto !important; cursor: pointer; position: relative;">
          <swiper #swiperRef3 [slidesPerView]="1" [spaceBetween]="30"
            [navigation]="{ nextEl: '.custom-next-button2', prevEl: '.custom-prev-button2' }"
            (slideChange)="onSlideChange2($event)" [breakpoints]="{
          '768': { 'slidesPerView': 3 }
        }" style="width: 75%;">
            <ng-template swiperSlide *ngFor="let cards of commercial.slice(3)">
              <app-rent-fuprop [propertyData]="cards"></app-rent-fuprop>
            </ng-template>
          </swiper>
        </div>
      </ng-container>

      <!-- Mobile View (Vertical Column) -->
      <ng-template #mobileCommers>
        <div
          style="display: flex; flex-direction: column; gap: 1rem; margin-top: 1pc;">
          <app-rent-fuprop *ngFor="let cards of commercial"
            [propertyData]="cards"></app-rent-fuprop>
        </div>
      </ng-template>
    </ng-template>

  </div>
  <div class="containerset">
    <div class="text-center mb-2">
      <div class="fw-bolds1">Why Fuprop</div>
      <p class="text-muteds1">
        Our seasoned team excels in real estate with years of successful market
        navigation, offering informed decisions and optimal results.
      </p>
    </div>

    <div class="rowbottom">
      <div class="cardbottom">
        <div class="icon-container">
          <img src="https://img.icons8.com/ios-filled/50/building.png"
            alt="Free Property Listings" />
        </div>
        <div>
          <div class="fw-semibolds1">Free Property Listings</div>
          <p class="text-muteda1">List your property at zero cost and reach
            <span class="highlight">a wide audience instantly</span>.</p>
        </div>
      </div>

      <div class="cardbottom">
        <div class="icon-container">
          <img src="https://img.icons8.com/ios-glyphs/30/phone.png"
            alt="Free Access to Contact Details" />
        </div>
        <div>
          <div class="fw-semibolds1">Free Access to Contact Details</div>
          <p class="text-muteda1"><span class="highlight">No hidden
              charges</span>—connect directly with buyers, sellers or
            tenants.</p>
        </div>
      </div>

      <div class="cardbottom">
        <div class="icon-container">
          <img src="https://img.icons8.com/ios-filled/50/real-estate.png"
            alt="Expert-Led Real Estate Services" />
        </div>
        <div>
          <div class="fw-semibolds1">Expert-Led Real Estate Services</div>
          <p class="text-muteda1">From legal support to home interiors, get
            end-to-end solutions delivered <span class="highlight">on
              time</span> with <span class="highlight">unmatched
              quality</span>.</p>
        </div>
      </div>

      <div class="cardbottom">
        <div class="icon-container">
          <img
            src="https://img.icons8.com/ios-filled/50/000000/money-transfer.png"
            alt="Zero Brokerage" />
        </div>
        <div>
          <div class="fw-semibolds1">Zero Brokerage</div>
          <p class="text-muteda1">Say goodbye to middleman. Fuprop ensures <span
              class="highlight">transparent, commission-free</span>
            transactions.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="containersetboot">
    <div class="fw-bolds1">Request Services</div><br>

    <div class="services-grid">
      <div class="service-card">
        <span>Loan</span>
        <i class="fas fa-hand-holding-usd"></i>
      </div>
      <div class="service-card">
        <span>Property Verification</span>
        <i class="fas fa-shield-alt"></i>
      </div>
      <div class="service-card">
        <span>Registry</span>
        <i class="fas fa-file-contract"></i>
      </div>
      <div class="service-card">
        <span>Rent Agreement</span>
        <i class="fas fa-handshake"></i>
      </div>
      <div class="service-card">
        <span>House Cleaning</span>
        <i class="fas fa-broom"></i>
      </div>
      <div class="service-card">
        <span>WhiteWash</span>
        <i class="fas fa-paint-roller"></i>
      </div>
      <div class="service-card">
        <span>Construction & Repair</span>
        <i class="fas fa-tools"></i>
      </div>
      <div class="service-card">
        <span>Packer and mover</span>
        <i class="fas fa-truck-moving"></i>
      </div>
    </div>
    <br>
    <div class="center">
      <!-- Trigger Button -->
      <!-- <button class="btn btn-primary setbutton" (click)="openService()">Service
        Request</button> -->
             <button class="service-btns setbutton" (click)="openServiceRequest('')">Service
        Request</button>

      <!-- Modal wrapper shown only when needed -->
      <ng-container *ngIf="showModal">
        <div #menuModal class="modal fade" id="menuModal" tabindex="-1"
          aria-labelledby="menuModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="menuModalLabel"></h5>
                <div
                  (click)="closeModal()"
                  role="button"
                  aria-label="Close"
                  style="cursor: pointer; font-size: 30px; color: #004aad; font-weight: 700;">
                  &times;
                </div>
              </div>
              <div class="modal-body">
                <div class="form-service ">
                  <div class="setlabel">Service Request</div><br>
                  <p class="subtext">Get a Free Consultation – A Propease
                    Executive Will Reach Out to You Shortly!</p>

                  <form [formGroup]="serviceform" (ngSubmit)="onService()">
                    <label>Name</label>
                    <input type="text" formControlName="name"
                      placeholder="Enter Your Full Name">

                    <label>Phone no.</label>
                    <!-- <input type="text" formControlName="phoneNumber"
                      placeholder="Enter Your Mobile Number" (input)="onInput($event)" > -->
                    <div class="input-group custom-input-groupre">
                      <span class="input-group-textre">+91</span>
                      <input
                        type="text"
                        class="controlpromobilere"
                        formControlName="phoneNumber"
                        placeholder="Enter your phone number"
                        (input)="onInput($event)">
                    </div>

                    <label>Email</label>
                    <input type="email" formControlName="email"
                      placeholder="Enter Your Email Id" required>

                    <div class="services">
                      <label>Request Services</label>
                      <div class="service-chips">
                        <div
                          *ngFor="let service of services"
                          [class.selected]="selectedService === service"
                          (click)="toggleService(service)">
                          {{ service }}
                        </div>
                      </div>
                    </div>

                    <label>Add requirement in details</label>
                    <textarea formControlName="requirementDetail"
                      placeholder="Type here..."></textarea>

                    <button type="submit" class="service-btn setbutton">Submit</button>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>

  </div>

  <div *ngIf="showTopIcon" class="top-icon setbutton" (click)="scrollToTop()">
    ⬆
  </div>

  <br>
  <app-footer></app-footer>
</div>
